export const ghgCategories = {
	// Scope 1
	'Stationary Combustion': 'Stasjonær forbrenning',
	'Mobile Combustion': 'Mobil forbrenning',
	'Process Emissions': 'Prosessutslipp',
	'Fugitive Emissions': 'Lekkasjer og utslipp av gasser',
	// Scope 2
	'Purchased Electricity': 'Innkjøpt elektrisitet',
	'Purchased Steam, Heat, or Cooling': 'Innkjøpt damp, varme eller kjøling',
	// Scope 3
	'Purchased Goods and Services': 'Innkjøp av varer og tjenester',
	'Capital Goods': 'Anleggsmidler',
	'Fuel and Energy Related Activities': 'Utslipp relatert til energiproduksjon',
	'Transportation and Distribution (Upstream)':
		'Kjøpt transport og distribusjon',
	'Waste Generated in Operations': 'Avfallshåndtering',
	'Business Travel': 'Tjenestereiser',
	'Employee Commuting': 'Ansattes reiser til og fra jobb',
	'Leased Assets (Upstream)': 'Leie av lokaler eller utstyr',
	'Transportation and Distribution (Downstream)':
		'Nedstrøms transport og distribusjon',
	'Processing of Sold Products': 'Prosessering av solgte produkter',
	'Use of Sold Products': 'Bruk av solgte produkter',
	'End-of-Life Treatment of Sold Products':
		'Sluttbehandling av solgte produkter',
	'Leased Assets (Downstream)': 'Utleie av lokaler eller utstyr',
	Franchises: 'Franchiser',
	Investments: 'Investeringer',
	unknown: 'Ukjent',
	Others: 'Andre kategorier',
}
